import type { FC } from "react";

import AppleCalendarIconSVG from "@/ui/theme/icons/calendar/AppleCalendarIconSVG";
import GoogleCalendarIconSVG from "@/ui/theme/icons/calendar/GoogleCalendarIconSVG";

enum CalendarType {
  Apple = "apple",
  Google = "google",
}

interface CalendarTypeAttributes {
  Icon: FC<Partial<SizeDimensions>>;
  name: string;
}

const CalendarTypeDefinitions: Record<CalendarType, CalendarTypeAttributes> = {
  [CalendarType.Apple]: {
    Icon: AppleCalendarIconSVG,
    name: "Apple Calendar",
  },
  [CalendarType.Google]: {
    Icon: GoogleCalendarIconSVG,
    name: "Google Calendar",
  },
};

export { CalendarType, CalendarTypeDefinitions };
